/** @format */

const localDict = {
  '告警服务升级了，查看如何': 'The alert service has been upgraded. Please check how to ',
  配置告警策略: 'configure alert policies',
  设置默认策略: 'Set Default Policy',
  禁用状态下的策略不可设置为默认策略: 'Disabled policies cannot be set as the default policy',
  项目关联的策略不可设置为默认策略:
    'Policies associated with projects cannot be set as the default policy',
  '是否确认设置当前默认策略？': 'Are you sure you want to set the current policy as the default?',
  '每类产品下只允许有一项默认策略。若当前产品下已有默认策略，开启后，之前的默认策略会变为“非默认”状态':
    'Only one default policy is allowed per product type. If a default policy already exists for the current product, the previous one will become non-default after enabling this setting',
  确认设置: 'Confirm Setting',
  取消默认策略: 'Cancel Default Policy',
  默认策略不能删除: 'Default policies cannot be deleted',
  '确认删除当前策略？': 'Are you sure you want to delete the current policy?',
  策略删除成功: 'Policy deleted successfully',
  策略删除失败: 'Policy deletion failed',
  默认策略不能禁用: 'Default policies cannot be disabled',
  关联模板名称: 'Associated Template Name',
  近5分钟: 'Last 5 Minutes',
  近3小时: 'Last 3 Hours',
  '共{n}个视图': 'Total {n} Views',
  我的收藏: 'My Favorites',
  请输入产品名称进行搜索: 'Please enter the product name to search',
  周期聚合方式: 'Aggregation Method',
  维度: 'Dimensions',
  默认全部维度: 'Default All Dimensions',
  默认为全部: 'Default All',
  批量解绑: 'Batch Unbind',
  实例ID: 'Instance ID',
  请选择事件: 'Please select an event',
  选择模版: 'Select Template',
  手动匹配: 'Manual Matching',
  触发条件: 'Trigger Condition',
  触发方式: 'Trigger Method',
  条件触发模版: 'Conditional Trigger Template',
  请选择条件触发模版: 'Please select a conditional trigger template',
  新建模板: 'Create Template',
  修改模板: 'Modify Template',
  在5分钟内: 'In 5 minutes',
  在10分钟内: 'In 10 minutes',
  在30分钟内: 'In 30 minutes',
  在60分钟内: 'In 60 minutes',
  在3小时内: 'In 3 hours',
  在6小时内: 'In 6 hours',
  在12小时内: 'In 12 hours',
  在24小时内: 'In 24 hours',
  告警一次: 'Alert Once Every',
  间隔5分钟告警一次: '5 minutes',
  间隔10分钟告警一次: '10 minutes',
  间隔15分钟告警一次: '15 minutes',
  间隔30分钟告警一次: '30 minutes',
  间隔1小时告警一次: '1 hour',
  间隔3小时告警一次: '3 hours',
  间隔6小时告警一次: '6 hours',
  间隔12小时告警一次: '12 hours',
  间隔1天告警一次: '1 day',
  累计触发: 'Accumulated Trigger',
  触发: 'Trigger',
  '共{x}个资源告警数': 'Total {x} Resource Alerts',
  所属项目: 'Project',
  标签: 'Tag',
  告警策略名称: 'Alert Policy Name',
  触发时间: 'Trigger Time',
  关联硬盘ID: 'Associated Disk ID',
  正在告警资源: 'Alarming Resources',
  下载成功: 'Download Success',
  所选产品暂无数据: 'No data for the selected product',
  '输入实例ID、实例名称': 'Please enter the instance ID or instance name',
  关联云硬盘: 'Associated Cloud Disk',
  云硬盘ID: 'Disk ID',
  触发条件模版: 'Condition Template',
  模版名称: 'Template Name',
  模板描述: 'Template Description',
  绑定策略数: 'Bound Policies',
  最后修改时间: 'Last Modified Time',
  确定删除所选触发条件模板:
    'Are you sure you want to delete the selected trigger condition template?',
  请输入模版名称: 'Please enter the template name',
  展开全部: 'Expand All',
  收起: 'Collapse',
  '共{n}条': 'Total {n} Items',
  请正确填写阈值告警规则: 'Please fill in the threshold alarm rule correctly',
  至少填写一条告警规则: 'Please fill in at least one alarm rule',
  修改触发条件模版: 'Modify Trigger Condition Template',
  新建触发条件模版: 'Create Trigger Condition Template',
  次则: 'time then',
  批量编辑: 'Batch Edit',
  批量删除: 'Batch Delete',
  请至少保留一条事件: 'Please keep at least one event',
  请选择事件名称: 'Please select an event',
  '点击“确定”后，配置策略将对已勾选的多个事件生效':
    'After clicking “Confirm”, the configured policy will take effect for multiple selected events.',
  告警屏蔽: 'Alarm Shielding',
  规则名称: 'Rule Name',
  未启用: 'Disabled',
  启用中: 'Enabled',
  生效中: 'In Effect',
  已失效: 'Expired',
  事件: 'Event',
  全部指标: 'All Metrics',
  全部事件: 'All Events',
  屏蔽条件: 'Shielding Conditions',
  绑定实例: 'Bound Instances',
  规则描述: 'Rule Description',
  生效时段: 'Effective Period',
  永久屏蔽: 'Permanent Shielding',
  绝对时间范围: 'Absolute Time Range',
  循环日期: 'Cycle Date',
  时间范围: 'Time Range',
  永久: 'Permanent',
  是否启用: 'Daily Cycle',
  确定删除所选规则: 'Are you sure you want to delete the selected rule?',
  新建屏蔽规则: 'Create Shielding',
  请输入规则名称: 'Please enter the rule name',
  请输入描述: 'Please enter the description',
  修改屏蔽规则: 'Modify Shielding',
  屏蔽类型: 'Shielding Type',
  '输入查询值超过100个，请减少查询值个数后重试':
    'The number of query values exceeds 100. Please reduce the number of query values and try again.',
  单个资源模糊搜索: 'Single resource fuzzy search',
  '多个资源精确搜索，支持回车、空格、分号、逗号分隔符':
    'Multiple resource precise search, supported by Enter, space, semicolon, comma separator',
  请选择资源分组: 'Please select resource group',
  全局搜索: 'Global Search',
  实例屏蔽: 'Instance Shielding',
  屏蔽范围: 'Shielding Range',
  指定指标: 'Specified Metrics',
  指定事件: 'Specified Events',
  请选择屏蔽范围: 'Please select shielding range',
  生效时间范围: 'Effective Time Range',
  请选择生效时间范围: 'Please select effective time range',
  永久生效: 'Permanent Effective',
  '相对时间范围(每天循环)': 'Relative Time Range (Daily Cycle)',
  循环时间: 'Cycle Time',
  '请输入TagValue，默认全部生效，多个值使用,隔开':
    'Please enter TagValue, default all effective, multiple values using, separated',
  '请选择维度，默认为全部维度': 'Please select dimension, default all dimensions',
  云产品监控: 'Cloud Product',
  Prometheus监控: 'Prometheus Monitor',
  指标探索: 'Metric Explore',
  告警管理: 'Alarm Management',
  Grafana服务: 'Grafana Service',
  自动化运维: 'Automation Operations',
  触发器: 'Triggers',
  自动化场景: 'Automation Scenarios',
  执行记录: 'Execution Records',
  公共函数: 'Public Functions',
  未发送: 'Not Sent',
  回调地址: 'Callback URL',
  不满足告警通知时间范围: 'The alarm notification time range is not met',
  不满足累计告警次数: 'The accumulated alarm count is not met',
  不满足告警通知间隔: 'The alarm notification interval is not met',
  不满足维度标签: 'The dimension label is not met',
  已发出: 'Sent',
  已屏蔽: 'Shielded',
  已抑制: 'Suppressed',
  结果: 'Result',
  '紧急（Critical）：邮件、短信、电话均会通知。':
    'Critical: Email, SMS, and phone notifications will be sent.',
  '严重（Error）：邮件、短信通知。': 'Error: Email and SMS notifications will be sent.',
  '警告（Warning）：仅邮件通知。': 'Warning: Only email notifications will be sent.'
}

// 替换之前配置错误的key
export const localDictCn = {
  '告警服务升级了，查看如何': '告警服务升级了，查看如何',
  '共{n}个视图': '共{n}个视图',
  '在{n}内': '在{n}内',
  '间隔{n}告警一次': '间隔{n}告警一次',
  '共{x}个资源告警数': '共{x}个资源告警数',
  '共{n}条': '共{n}条'
}

export default localDict
